export default __webpack_public_path__ + "156db0f046d9498879e5479f9a935629.svg";